import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import { MainUniverseItemRenderer } from '../menus/MainUniverseItemRenderer';
import masterUniverseUtils from '../../components/utils/MasterUniverseUtils';
import properties from '../../constants/Properties';

const MainUniversesListContent = React.createClass({
    getInitialState() {
        return {
            elements: [],
            windowHeight: this.props.windowHeight
        };
    },
    checkElements() {
        if (this.state && this.state.elements.length > 0 && this.state.windowHeight == this.props.windowHeight)
            return;

        setTimeout(function() {
            var elements = this.getElements();

            this.setState({
                elements,
                windowHeight: this.props.windowHeight
            });
        }.bind(this), 10);
    },
    getElements() {
        var items = masterUniverseUtils.getMainUniversesList();
        var elementsLength = Object.keys(items).length;
        var item;
        var elements = [];
        var key;
        var i=0;
        var listHeight = this.props.windowHeight - properties.CLIPART_BUTTON_HEIGHT - properties.BROWSER_BUTTON_HEIGHT - 10 - 10;

        for (key in items) {
            item = items[key];
            elements.push(<MainUniverseItemRenderer dispatch={this.props.dispatch} listHeight={listHeight} itemsLength={elementsLength} accordionWidth={this.props.accordionWidth} index={i} item={item} refreshValue={this.props.refreshValue} key={'mainUniverseSelector' + i}/>);
            i = i + 1;
        }

        return elements;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.elements != nextState.elements || this.props.isUniversesVisible != newProps.isUniversesVisible || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth || this.props.refreshValue != newProps.refreshValue)
            return true;
        else
            return false;
    },
    render() {
        if (this.state == undefined || this.state.elements == undefined)
            return (<div/>);

        this.checkElements();

        const listStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_COLOR,
            width: this.props.accordionWidth,
            height: this.props.windowHeight - properties.CLIPART_BUTTON_HEIGHT - properties.BROWSER_BUTTON_HEIGHT,
            top: properties.CLIPART_BUTTON_HEIGHT + properties.BROWSER_BUTTON_HEIGHT,
            left: 0,
            overflowX: 'hidden',
            overflowY: 'hidden'
        };

        const topPadding = 10;
        const bottomPadding = 10;
        const items = this.state.elements;
        const scrollWidth = 15;
        const hGap = 10;
        const bottomGap = 10;
        const buttonWidth = this.props.accordionWidth - 2 * hGap - scrollWidth;
        var itemHeight = buttonWidth * 1 / 3 + bottomGap;
        var listHeight = this.props.windowHeight - properties.CLIPART_BUTTON_HEIGHT - properties.BROWSER_BUTTON_HEIGHT - topPadding - bottomPadding;
        var scrollHeight = items.length * itemHeight;

        if (scrollHeight < listHeight)
            scrollHeight = listHeight;

        var componentProperties = {};
        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = this.props.accordionWidth;
        componentProperties.top = topPadding;
        componentProperties.displayState = 'block';
        componentProperties.elements = items;
        componentProperties.backgroundColor = properties.BROWSER_COLOR;
        componentProperties.height = listHeight;
        componentProperties.scrollHeight = scrollHeight;

        return (
            <div style={listStyle}>
                <ScrollableComponent componentProperties={componentProperties}/>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var accordionWidth = state.accordion.width;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    return {
        accordionWidth
    };
}

export const MainUniversesList = connect(mapStateToProps)(MainUniversesListContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/MainUniversesList.js
 **/